import {
  type RGB,
  parseColor,
  rgbToLab,
  labToRgb,
  rgbBrightness,
  clampLab,
  rgbToHex,
} from "./dark-mode-color-math";

export type ColorRole = "background" | "text" | "border";

/**
 * Gmail Android's aggressive auto-invert: black ↔ white, brand mid-tones
 * preserved. Real Gmail Android ignores authored `@media
 * (prefers-color-scheme: dark)` CSS and forces this algorithm regardless,
 * so the simulator matches by running unconditionally.
 */
export function transformColor(color: RGB, role: ColorRole): RGB {
  const brightness = rgbBrightness(color);
  if (role === "text" || role === "border") {
    if (brightness < 150) {
      const lab = rgbToLab(color);
      return labToRgb(clampLab({ ...lab, L: 100 - lab.L }));
    }
  } else if (role === "background") {
    if (brightness > 205) {
      const lab = rgbToLab(color);
      return labToRgb(clampLab({ ...lab, L: 100 - lab.L }));
    }
  }
  return color;
}

export function transformColorString(
  colorStr: string,
  role: ColorRole,
): string | null {
  const rgb = parseColor(colorStr);
  if (!rgb) return null;
  return rgbToHex(transformColor(rgb, role));
}
